<template>
  <div v-if="patientVisit">
    <div>
      <div class="py-3 px-4 flex items-center">
        <span class="title text-2xl text-black mr-2">{{ $t("Thông tin khám bệnh") }}</span>
        <!-- <template v-if="isHasEHCSync">
          <el-tooltip class="item" effect="dark" content="Đồng bộ dữ liệu từ EHC" placement="top">
            <el-button
              size="small"
              :class="{
    disabled: isSyncing,
  }"
              :disabled="isSyncing"
              @click="handleSyncEHC()"
            >
              <span v-if="!isSyncing">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-refresh-cw"
                >
                  <polyline points="23 4 23 10 17 10" />
                  <polyline points="1 20 1 14 7 14" />
                  <path
                    d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                  />
                </svg>
              </span>
              <i v-else class="el-icon-loading text-xl" />
            </el-button>
          </el-tooltip>
        </template>-->
      </div>
      <div class="m-3 px-2">
        <div>
          <div
            class="position-relative p-1 rounded-lg bg-white text-black border-current shadow-2xl transition-all h-20"
          >
            <div class="btn-base justify-center flex">
              <el-tooltip :content="$t('Quay lại')" placement="right">
                <div
                  @click="goBack"
                  role="button"
                  class="lg:absolute lg:right-4 lg:top-4 inline-block w-12 h-12 bg-white rounded-circle overflow-hidden"
                >
                  <span
                    class="flex w-12 h-12 align-middle border rounded-circle hover:bg-blue-100 transition-all duration-200"
                  >
                    <i class="el-icon-close m-auto text-2xl" />
                  </span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="relative row m-3">
        <div class="col-6">
          <div class="rounded-lg bg-white text-black border-current shadow-2xl mb-2">
            <div class="p-3">
              <div class="flex">
                <p class="p-0 m-0 fs-20 fw-500">Thông tin lượt khám</p>
                <div class="ml-auto" :set="(status = getApptStatus(patientVisit.status))">
                  <div :class="status.class" class="border rounded-full">
                    <div class="py-1 px-2">{{ status.text }}</div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div class="row">
                  <p class="text-secondary col">Họ và tên:</p>
                  <p class="col">{{ patientVisit.person && patientVisit.person.name }}</p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Giới tính:</p>
                  <p class="col">
                    {{
                    patientVisit.person
                    ? getGender(patientVisit.person.gender)
                    : ""
                    }}
                  </p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Ngày sinh:</p>
                  <p class="col">
                    {{
                    patientVisit.person &&
                    getPersonInfoString(patientVisit.person)
                    }}
                  </p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Điện thoại:</p>
                  <p class="col">{{ patientVisit.person ? patientVisit.person.phone : "" }}</p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Địa chỉ:</p>
                  <p class="col">{{ getAddress(patientVisit.person) }}</p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Hình thức:</p>
                  <p class="col">
                    {{
                    patientVisit.method == 1
                    ? $t("schedule_page.lbl_at_workspace")
                    : $t("schedule_page.lbl_video")
                    }}
                  </p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Bác sĩ:</p>
                  <p
                    class="col"
                  >{{ patientVisit.doctor && patientVisit.doctor.User && patientVisit.doctor.User.name || patientVisit.doctor_ref_name }}</p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Thời gian:</p>
                  <p class="col">
                    {{ getTime(patientVisit.start_time) }} -
                    {{ formatDateDMY(patientVisit.start_time) }}
                  </p>
                </div>
                <div class="row">
                  <p class="text-secondary col">Lý do khám:</p>
                  <p class="col">
                    {{
                    patientVisit.visit_reason ||
                    this.$t("schedule_page.lbl_dont_have")
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <OnlineRoom v-if="patientVisit.method === APPOINTMENT_METHOD_STATUS.CODE.ONLINE" />
          <UploadFile
            :patient-visit-files="patientVisit.patient_visit_file || []"
            :id="patientVisit.id"
            :status-patient-visit="patientVisit.status"
            @refresh="getPatientVisit"
          />
        </div>

        <div class="rounded-lg text-black border-current col-6">
          <b-overlay
            no-center
            rounded="sm"
            :show="patientVisit.status === EXAMINATION_STATUS.CODE.WAITING ||
            patientVisit.status === EXAMINATION_STATUS.CODE.MISSING
            "
          >
            <template #overlay>
              <div class="flex h-full">
                <div class="m-auto text-lg text-center px-3">
                  <i class="el-icon-warning-outline text-4xl text-yellow-600"></i>
                  <div>
                    {{
                    $t(
                    "Bạn cần bắt đầu lượt khám để có thể thực hiện các chức năng bên dưới"
                    )
                    }}
                  </div>
                </div>
              </div>
            </template>
            <div class="rounded-lg p-3 hover:bg-gray-100 shadow-2xl bg-white mb-2">
              <SelectDiseaseICD10 :dataIcd="diseaseICD" :disabled="true" />
            </div>
            <ConsulationTemp :patient-visit="patientVisit" @refresh="getPatientVisit" />
            <PrescriptionTemp :patient-visit="patientVisit" @refresh="getPatientVisit" />
            <indication-temp
              :name="$t('Xét nghiệm')"
              :type="INDICATION_TYPES.CODE.TEST_FORM"
              :consultation="consultationSms"
              :patient-visit="patientVisit"
              @refresh="getPatientVisit"
            />
            <indication-temp
              :name="$t('Chẩn đoán hình ảnh')"
              :type="INDICATION_TYPES.CODE.ULTRASOUND"
              :consultation="consultationSms"
              :patient-visit="patientVisit"
              @refresh="getPatientVisit"
            />
            <indication-temp
              :name="$t('Chỉ định khác')"
              :type="INDICATION_TYPES.CODE.OTHERS"
              :consultation="consultationSms"
              :patient-visit="patientVisit"
              @refresh="getPatientVisit"
            />
            <indication-temp
              :name="$t('Sinh học phân tử')"
              :type="INDICATION_TYPES.CODE.MOLECULAR_BIOLOGY"
              :consultation="consultationSms"
              :patient-visit="patientVisit"
              @refresh="getPatientVisit"
            />
          </b-overlay>
        </div>
      </div>
    </div>

    <el-dialog
      :visible="aleartSendResult"
      title="Thông báo"
      width="30%"
      :before-close="handeCloseAleartSendResult"
    >
      <div v-loading="loadingSendResult">
        <span class>Bạn có muốn gửi những thông tin sau đến người dùng?</span>
        <div class="mt-3">
          <div v-if="patientVisit.consultation" class="ml-2">
            <span v-if="patientVisit.consultation.sign">- Thông tin phiếu khám</span>
          </div>
          <div v-if="patientVisit.prescription.length > 0" class="ml-2">
            <span>- Thông tin đơn thuốc</span>
            <ul>
              <div v-for="item in patientVisit && patientVisit.prescription" :key="item.id">
                <li v-if="item.sign">{{ item.name }}</li>
              </div>
            </ul>
          </div>
          <div v-if="patientVisit.indication_order.length > 0" class="ml-2">
            <div
              v-if="
              patientVisit.indication_order.find(
                (x) => x.cate === 1 && x.indication.find((y) => y.sign)
              )
            "
            >
              <span>- Thông tin chỉ định xét nghiệm</span>
              <ul>
                <div
                  v-for="item in patientVisit &&
                  patientVisit.indication_order.find((x) => x.cate === 1)
                    .indication"
                  :key="item.id"
                >
                  <li v-if="item.sign">{{ item.name }}</li>
                </div>
              </ul>
            </div>
            <div
              v-if="
              patientVisit.indication_order.find(
                (x) => x.cate === 2 && x.indication.find((y) => y.sign)
              )
            "
            >
              <span>- Thông tin chỉ định siêu âm</span>
              <ul>
                <div
                  v-for="item in patientVisit &&
                  patientVisit.indication_order.find((x) => x.cate === 2)
                    .indication"
                  :key="item.id"
                >
                  <li v-if="item.sign">{{ item.name }}</li>
                </div>
              </ul>
            </div>

            <div
              v-if="
              patientVisit.indication_order.find(
                (x) => x.cate === 3 && x.indication.find((y) => y.sign)
              )
            "
            >
              <span>- Thông tin chỉ định khác</span>
              <ul>
                <div
                  v-for="item in patientVisit &&
                  patientVisit.indication_order.find((x) => x.cate === 3)
                    .indication"
                  :key="item.id"
                >
                  <li v-if="item.sign">{{ item.name }}</li>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div class="flex">
          <span class="dialog-footer ml-auto">
            <el-button @click="aleartSendResult = false">Thoát</el-button>
            <el-button type="primary" @click="sendResult()">Đồng ý</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ConsulationTemp from '@/components/PatientVisitHealthRecord/ConsulationTemp.vue'
import statusAppt from '@/constants/statusAppt'
import appUtils from '@/utils/appUtils'
import {
  APPOINTMENT_METHOD_STATUS,
  EXAMINATION_STATUS,
  INDICATION_TYPES
} from '@/utils/constants'
import ModalSelectHR from '@components/Appointment/ModalSelectHR.vue'
import IndicationTemp from '@components/PatientVisitHealthRecord/IndicationTemp.vue'
import OnlineRoom from '@components/PatientVisitHealthRecord/OnlineRoomTemp.vue'
import PrescriptionTemp from '@components/PatientVisitHealthRecord/PrescriptionTemp.vue'
import UploadFile from '@components/PatientVisitHealthRecord/UploadFilesTemp.vue'
import SelectDiseaseICD10 from '@components/SelectDiseaseICD10/index.vue'
import ModalAddConsultation from '@pages/HealthRecords/ModalAddConsultation.vue'
import PhieuKhamBenhDetail from '@pages/HealthRecords/PhieuKhamBenh/ModalAdd.vue'
import ModalViewConsultation from '@pages/HealthRecords/PhieuKhamBenh/ViewPhieuKham.vue'
import { BIcon, BOverlay } from 'bootstrap-vue'
import { mixinGetPersonInfo } from '@/utils/mixinGetPersonInfo'

export default {
  name: 'PatientVisitDetail',
  mixins: [mixinGetPersonInfo],
  components: {
    BIcon,
    BOverlay,
    ConsulationTemp,
    ModalSelectHR,
    ModalAddConsultation,
    PhieuKhamBenhDetail,
    ModalViewConsultation,
    IndicationTemp,
    PrescriptionTemp,
    OnlineRoom,
    UploadFile,
    SelectDiseaseICD10
  },
  computed: {
    // isDisabledResult () {
    //   if (this.patientVisit) {
    //     if (this.patientVisit.consultation) {
    //       if (this.patientVisit.consultation.sign) {
    //         return false
    //       }
    //     }
    //     if (this.patientVisit.prescription) {
    //       if (this.patientVisit.prescription.find(e => e.sign != null)) {
    //         return false
    //       }
    //     }
    //     if (this.patientVisit.indication_order) {
    //       if (
    //         this.patientVisit.indication_order.find(e =>
    //           e.indication.find(y => y.sign != null)
    //         )
    //       ) {
    //         return false
    //       }
    //     }
    //   }
    //   return true
    // },
    isHasEHCSync () {
      const settings = appUtils.isJSON(this.$globalClinic?.settings)
        ? JSON.parse(this.$globalClinic?.settings)
        : {}
      return !!settings?.ehc_config
    }
  },
  data () {
    return {
      loadingSendResult: false,
      aleartSendResult: false,
      loading: false,
      DialogVisibleStatus: false,
      consultationSms: {},
      root_type: 1,
      appointment: null,
      clinic_id: null,
      doctor_id: null,
      request_id: null,
      request: null,
      person: null,
      person_id: null,
      appt_edit: null,
      selectedHr: null,
      statusAppt,
      valueStatus: '',
      patientVisit: null,
      INDICATION_TYPES,
      showExtendButton: false,
      EXAMINATION_STATUS,
      timer: null,
      listIndicationNonResults: [],
      APPOINTMENT_METHOD_STATUS,
      diseaseICD: {},
      isSyncing: false
    }
  },
  created () {
    const self = this

    if (!self.$route.params?.id) {
      self.$router.push({ path: '/doctor/appointment-management' })
      return
    }

    self.getPatientVisit()

    self.timer = setInterval(function () {
      self.getPatientVisit()
    }, 1000 * 30) // refetch 30s
  },
  mounted () {
    const self = this

    // let user = this.$user
    self.clinic_id = this.$clinicId
  },
  destroyed () {
    this.$bus.off('change:status')
    this.cancelAutoUpdate()
  },
  watch: {
    patientVisit (data) {
      this.patientVisit = data
    }
  },
  methods: {
    handeCloseAleartSendResult () {
      this.aleartSendResult = false
    },
    cancelAutoUpdate () {
      clearInterval(this.timer)
    },
    async getPatientVisit () {
      const self = this
      self.loading = true

      try {
        const id = self.$route.params?.id
        const result = await self.$rf
          .getRequest('DoctorRequest')
          .getDetailPatientVisit(id)

        if (result?.data) {
          self.patientVisit = result.data
          self.diseaseICD = {
            code: result.data?.icd_code || '',
            name: result.data?.icd_name || ''
          }
          self.consultationSms = {
            id: self.patientVisit?.appt?.consultation?.id,
            patient_visit_id: self.patientVisit?.id,
            health_record_id:
              self.patientVisit?.appt?.consultation?.health_record_id,
            indication_order: self.patientVisit?.indication_order
          }
          self.checkingIndicationFullResult(self.patientVisit?.indication_order)
          self.loading = false
        }
      } catch (error) {
        console.log('', error)
        self.loading = false
      } finally {
        self.loading = false
      }
    },
    checkingIndicationFullResult (orders) {
      if (!orders) return

      this.listIndicationNonResults = []

      /* eslint-disable no-unused-expressions */
      orders?.map(order => {
        order?.indication?.map(item => {
          if (!item?.examination_results) {
            this.listIndicationNonResults.push(item)
          }
        })
      })

      return !!this.listIndicationNonResults.length
    },
    getApptStatus (stt) {
      switch (stt) {
        case EXAMINATION_STATUS.CODE.WAITING:
          return {
            class: 'text-yellow-600 border-yellow-600 bg-yellow-50',
            text: 'Chờ khám'
          }
        case EXAMINATION_STATUS.CODE.WAITING_RESULT:
          return {
            class: 'text-red-600 border-red-600 bg-red-50',
            text: 'Chờ kết quả'
          }
        case EXAMINATION_STATUS.CODE.BEING:
          return {
            class: 'text-green-600 border-green-600 bg-green-50',
            text: 'Đang khám'
          }
        case EXAMINATION_STATUS.CODE.DONE:
          return {
            class: 'text-blue-600 border-blue-600 bg-blue-50',
            text: 'Đã khám xong'
          }
        case EXAMINATION_STATUS.CODE.CANCELED:
          return {
            class: 'text-red-600 border-red-600 bg-red-50',
            text: 'Đã hủy lượt'
          }
        case EXAMINATION_STATUS.CODE.WAITING_READ_RESULT:
          return {
            class: 'text-indigo-600 border-indigo-600 bg-indigo-50',
            text: 'Chờ đọc kết quả'
          }
        case EXAMINATION_STATUS.CODE.MISSING:
          return {
            class: 'text-gray-600 border-gray-600 bg-gray-50',
            text: 'Nhỡ lượt'
          }
        default:
          return {
            class: 'text-yellow-600 border-yellow-600 bg-yellow-50',
            text: 'Chờ khám'
          }
      }
    },
    async getConsultationById (id) {
      try {
        const self = this
        await this.$rf
          .getRequest('DoctorRequest')
          .getConsultationByIDV2(id)
          .then(res => {
            self.consultationSms = res.data
            console.log(self.consultationSms)
          })
      } catch (error) {
        console.log('', error)
      }
    },
    async sendResult () {
      try {
        if (!this.patientVisit.id) return
        const params = {
          patient_visit_id: this.patientVisit.id
        }
        this.loadingSendResult = true
        await this.$rf
          .getRequest('DoctorRequest')
          .sendResultPatientVisit(params)
          .then(res => {
            console.log(res)
            this.$message({
              message: 'Gửi kết quả thành công',
              type: 'success'
            })
            this.loadingSendResult = false
            this.aleartSendResult = false
          })
      } catch (error) {
        console.log('', error)
        this.loadingSendResult = false
        this.aleartSendResult = false
      }
    },
    goBack () {
      this.$router.go(-1)
      // this.$router.push({ path: '/doctor/patient-visit' })
    },
    getTime (date_time) {
      return window
        .moment(date_time)
        .utc()
        .format('HH:mm:ss')
    },
    formatDateDMY (date_time) {
      return (
        date_time &&
        window
          .moment(date_time)
          .utc()
          .format('DD/MM/YYYY')
      )
    },
    getPersonInfoString (p) {
      if (!p.birthday) return ''

      return (
        this.formatDateDMY(p.birthday) +
        ' (' +
        this.getAges(p.birthday) +
        ')' +
        (p.career ? ', ' + p.career : '')
      )
    },
    getGender (gender = 1) {
      return gender === 1
        ? this.$t('schedule_page.lbl_male')
        : gender === 2
          ? this.$t('schedule_page.lbl_female')
          : gender === 3
            ? this.$t('schedule_page.lbl_other')
            : ''
    },
    getAges (date) {
      let bd = window.moment(date)
      let age = window.moment().diff(bd, 'years')
      return age + this.$t('schedule_page.lbl_age')
    },
    getStatusAppt (status) {
      if (status === undefined || status === null) return ''
      return this.statusAppt[status]
    },
    async updateStatusPatient (stt) {
      let _confirm = null

      if (
        stt === EXAMINATION_STATUS.CODE.MISSING &&
        (this.patientVisit.status === EXAMINATION_STATUS.CODE.BEING ||
          this.patientVisit.status ===
            EXAMINATION_STATUS.CODE.WAITING_READ_RESULT)
      ) {
        _confirm = await this.$confirm(
          this.$t('Bạn chắc chắn muốn bỏ qua lượt khám này?'),
          this.$t('Cảnh báo'),
          {
            dangerouslyUseHTMLString: true
          }
        ).catch(_ => {})

        if (!_confirm) return
      }

      if (stt === EXAMINATION_STATUS.CODE.DONE) {
        _confirm = await this.$confirm(
          this.$t('Kết thúc lượt khám cho bệnh nhân này?'),
          this.$t('Cảnh báo'),
          {
            dangerouslyUseHTMLString: true
          }
        ).catch(_ => {})

        if (!_confirm) return

        this.showExtendButton = false
      }

      this.patientVisit.status = stt
      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .updatePatientVisitsById(this.patientVisit.id, this.patientVisit)
        .then(res => {
          this.loading = false
          if (this.patientVisit.status === EXAMINATION_STATUS.CODE.MISSING) {
            this.$router.push({
              name: 'PatientVisitManagement',
              query: {
                tab: EXAMINATION_STATUS.NAME.MISSING.toLowerCase().replace(
                  '_',
                  '-'
                )
              }
            })
          }
          // this.getPatientVisit()
        })
        .catch(e => {
          console.log(e)
        })
    },
    async handleSyncEHC () {
      const self = this
      const person = this.patientVisit?.person

      if (!this.patientVisit?.id || !person?.id) return

      try {
        self.isSyncing = true
        const params = {
          org_id: self.$globalClinic?.org_id,
          ws_id: self.$globalClinic?.id,
          person_id: person?.id,
          medical_record_ref_id: person?.ref_id,
          patient_visit_id: this.patientVisit?.id
        }

        await self.$rf
          .getRequest('EHCSyncRequest')
          .ehcSyncIndicationHealthRecords(params)
          .then(res => {
            if (!res?.data) return
            if (res?.data?.code === 401) {
              self.$message({
                type: 'error',
                message: self.$t(`Bạn không thể đồng bộ dữ liệu từ EHC`)
              })
              console.log(res)
              return
            }
            self.getPatientVisit()
            self.$message({
              type: 'success',
              message: self.$t(`Đồng bộ dữ liệu thành công`)
            })
            self.isSyncing = false
          })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="scss">
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

#appointment_detail_img {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.appointment-person-info .person-name {
  padding-left: 16px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.appointment-person-info .person-avatar .avatar {
  --tblr-avatar-size: 64px;
}

.header-title {
  width: calc(100% - 32px);
}

.btn-c {
  background-color: #20419b;
  color: white;
  border: none;
}

.btn-d {
  background-color: #1a80fd;
  color: white;
  border: none;
}

.btn-drop-shadow {
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.2),
    0 2px 4px -1px rgba(0, 0, 0, 0.6);

  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

  &:active {
    --tw-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.6);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  &-sm {
    --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

    &:active {
      --tw-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }
  }
}

.hodo-table table {
  border-collapse: collapse !important;
  width: 100% !important;
  border: 1px solid #dbdde0 !important;
  margin-top: 1rem !important;
}

.hodo-table table thead th {
  text-transform: uppercase !important;
}

.hodo-table table th,
.hodo-table table td {
  padding: 8px !important;
  border: 1px solid #dbdde0 !important;
}
</style>
